export const MAX_SEGMENTS_BREADCRUMBS = 4;
